import { createFileRoute, Navigate } from "@tanstack/react-router";

/** Legacy bookmark — staff sign in on /login now. */
export const Route = createFileRoute("/admin/login")({
  component: () => <Navigate to="/login" />,
});
